$(document).ready(function() {

    $('.js-hp-video-sound-off-icon, .js-hp-video-sound-icon').click( function (){
        if( $('.js-hp-video').prop('muted') ) {
            $('.js-hp-video').prop('muted', false);
            $('.js-hp-video-sound-off-icon').hide();
            $('.js-hp-video-sound-icon').show();
        } else {
            $('.js-hp-video').prop('muted', true);
            $('.js-hp-video-sound-off-icon').show();
            $('.js-hp-video-sound-icon').hide();
        }
    });

    $('.hp-main-photo').addClass('show');

    $('.projekt-kategoria').click(function(){
        let cat = $(this).attr('data-cat');
        $('.projekt-kategoria').removeClass('active');
        $('.projekt-kategoria[data-cat="'+ cat +'"]').addClass('active');
        $('.projekt-item').hide();
        $('.projekt-item[data-cat*=",'+ cat +',"], .projekt-item[data-cat*="['+ cat +',"]').fadeIn();
    })

    $('.js-desktop-hamburger-menu').click(function(){
        $(this).fadeOut(function(){
            $('.desktop-menu-items').fadeIn();
            createCookie('desktop_menu', 1, 30);
        });
    })

    $('.hp-top-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: '<button type="button" class="no-btn slick-arrow slick-arrow-prev" title="Predcházajúci"><img width="39" height="40" src="https://hiroas.sk/wp-content/uploads/2021/01/arrow-left.png" alt="Predcházajúci"></button>',
        nextArrow: '<button type="button" class="no-btn slick-arrow slick-arrow-next" title="Nasledujúci"><img width="41" height="40" src="https://hiroas.sk/wp-content/uploads/2021/01/arrow-right-1.png" alt="Nasledujúci"></button>',
        dots: false,
    })

    $('.projekt-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: '<button type="button" class="no-btn slick-arrow slick-arrow-prev" title="Predcházajúci"><img src="https://hiroas.sk/wp-content/uploads/2021/01/arrow-left.png" alt="Predcházajúci"></button>',
        nextArrow: '<button type="button" class="no-btn slick-arrow slick-arrow-next" title="Nasledujúci"><img src="https://hiroas.sk/wp-content/uploads/2021/01/arrow-right-1.png" alt="Nasledujúci"></button>',
        dots: false,
    })

})
